import { PropsWithChildren } from 'react';
import { StyleSheet, View, useWindowDimensions } from 'react-native';
//import { RadialGradient } from 'react-native-gradients';
import Svg, {
  Defs,
  RadialGradient as SVGRadialGradient,
  Rect,
  Stop,
} from 'react-native-svg';

interface AppBackgroundProps {
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#ffe3fc',
  },
});

interface Color {
  offset: string;
  color: string;
  opacity: string;
};

const colorList = [
  { offset: '0%', color: '#d5fdff', opacity: '1' },
  { offset: '100%', color: '#ffe3fc', opacity: '1' }
];

const RadialGradient = ({ colorList, x, y, rx, ry }: {  colorList: Color[]; x: string | number; y: string | number; rx: string | number; ry: string | number}) => {
  const { width, height } = useWindowDimensions();
  return (
    <Svg width={width} height={height}>
      <Defs>
        <SVGRadialGradient
          id="grad"
          cx={x}
          cy={y}
          rx={rx}
          ry={ry}
          gradientUnits="userSpaceOnUse"
        >
          {colorList.map((value, index) => (
            <Stop
              key={`RadialGradientItem_${index}`}
              offset={value.offset}
              stopColor={value.color}
              stopOpacity={value.opacity}
            />
          ))}
        </SVGRadialGradient>
      </Defs>
      <Rect x="0" y="0" width={width} height={height} fill="url(#grad)" />
    </Svg>
  );
};

export default function AppBackground({ children }: PropsWithChildren<AppBackgroundProps>) {
  return (
    <View style={styles.container}>
      <View style={StyleSheet.absoluteFill}>
        <RadialGradient
          x="50%"
          y="50%"
          rx="50%"
          ry="50%"
          colorList={colorList}
        />
      </View>

      {children}

    </View>
  );
};
